import { motion } from 'framer-motion';

const reasons = [
  'Personalized Care & Patient Empowerment',
  'Proven, Evidence-Based Pharmaceutical Practice',
  'Trusted by Thousands in the Greater Toronto Area',
  'Emotional Support & Clear Communication',
  'Over 10 Licensed Pharmacists On Staff',
  'Addiction Treatment Partnership (TSCP Certified)',
];

export default function PharmacyWhyChoose() {
  return (
    <section aria-labelledby="why-choose-heading" className="mb-20">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="mb-9"
      >
        <p className="text-xs font-semibold text-teal-600 uppercase tracking-[0.15em] mb-4">Our Commitment</p>
        <h2 id="why-choose-heading" className="text-3xl font-bold text-gray-900 mb-3 leading-snug">
          Why choose Thornhill Drug-Mart
        </h2>
        <p className="text-gray-500 max-w-xl text-[0.94rem] leading-relaxed">
          We are more than a pharmacy — we are a community health partner dedicated to your well-being.
          Our team takes the time to truly understand your health goals and provides comprehensive support
          every step of the way.
        </p>
      </motion.div>

      {/* Reasons — clean 2-col list */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4 mb-12">
        {reasons.map((reason, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.065, ease: 'easeOut' }}
            className="flex items-center gap-3 py-3 border-b border-gray-200"
          >
            <i className="ri-check-line text-teal-600 text-base flex-shrink-0" aria-hidden="true"></i>
            <span className="text-sm text-gray-700 font-medium">{reason}</span>
          </motion.div>
        ))}
      </div>

      {/* Wide image with overlay */}
      <motion.div
        initial={{ opacity: 0, scale: 0.985 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.75, ease: 'easeOut' }}
        className="rounded-lg overflow-hidden w-full h-60 lg:h-72 relative"
      >
        <img
          src="https://readdy.ai/api/search-image?query=modern%20pharmacy%20team%20of%20pharmacists%20standing%20together%20in%20bright%20white%20teal%20interior%20professional%20confident%20healthcare%20workers%20welcoming%20smiling%20group%20photo%20modern%20canadian%20pharmacy%20Thornhill%20Ontario%20wide%20shot&width=1000&height=400&seq=phwhy-team-img&orientation=landscape"
          alt="Thornhill Drug-Mart pharmacy team"
          className="w-full h-full object-cover object-top"
          width={1000}
          height={400}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/75 via-gray-900/40 to-transparent flex items-center">
          <div className="px-10">
            <p className="text-white text-lg font-bold max-w-xs leading-snug mb-4">
              Thornhill&apos;s most trusted pharmacy since day one
            </p>
            <a
              href="tel:9057099985"
              className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold px-5 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line" aria-hidden="true"></i>
              (905) 709-9985
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
